module.exports = __webpack_public_path__ + "static/img/status-no-data.3fd6c72.png";